import { Projects } from '../project-list';

export const NameOfBlog: Projects = {
  id: 3,
  name: 'Blog',
  title: 'Blog: Book Reviews',
  timeLine: 'July 2020 - August 2020',
  myRole: 'Product Designer',
  team: 'Just me!',
  technology: 'Angular, Express.js, and Figma',
  content:
    // '<hr><h2>Introduction</h2><p></p><hr><h2>Process</h2><p></p><hr><h2>Looking Ahead</h2><p></p>',
    'Coming Soon...',
  description: 'Coming Soon...',
  key: 'NameOfBlog',
  date: 'July 2020',
  imageUrl: 'assets/Images/BlogSite.png',
  buttonText: 'View Code',
  buttonUrl: 'https://github.com/manasvimedam/BlogSite',
};
